import React, { useContext } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import SubmissionDetails from '../../../SubmissionDetails';
import { MobileContext } from '../../../Context';
import StatBlock from '../_partials/StatBlock';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export var DefaultDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, title = _b.title, publishedTime = _b.publishedTime, isMature = _b.isMature, author = _b.author, className = _a.className, contentClassName = _a.contentClassName;
    var isMobile = useContext(MobileContext);
    var isExtendedLoaded = !!deviation.extended;
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) },
        React.createElement("div", { className: s['title-block'] },
            React.createElement(SubmissionDetails, { author: author, publishedTime: publishedTime, views: get(deviation, 'extended.stats.views'), title: title, isMature: isMature, isLoaded: isExtendedLoaded }),
            !isMobile && isExtendedLoaded && (React.createElement(StatBlock, { views: get(deviation, 'extended.stats.views', 0), today: get(deviation, 'extended.stats.today', 0), publishedTime: publishedTime, isMature: isMature }))),
        isExtendedLoaded && React.createElement(ExtendedDetails, { deviation: deviation })));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
//# sourceMappingURL=Default.js.map